"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertRuleToNestedConditions = convertRuleToNestedConditions;

var _constants = require("./constants");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function convertRuleToNestedConditions(rule) {
  var masterClause = [];

  if (rule.where || rule.whereString) {
    masterClause = [].concat(_toConsumableArray(masterClause), [{
      or: [function () {
        switch (true) {
          case rule.isRegex:
            return _defineProperty({}, _constants.conditionNames.URL, {
              operator: _constants.defaultOperators.REGEX,
              value: rule.where
            });
          case rule.whereOperator !== undefined:
            switch (rule.whereOperator) {
              case "^":
                return _defineProperty({}, _constants.conditionNames.URL, {
                  operator: _constants.defaultOperators.STARTS_WITH,
                  value: rule.whereString
                });
              case "$":
                return _defineProperty({}, _constants.conditionNames.URL, {
                  operator: _constants.defaultOperators.ENDS_WITH,
                  value: rule.whereString
                });
              case "*":
                return _defineProperty({}, _constants.conditionNames.URL, {
                  operator: _constants.defaultOperators.CONTAINS,
                  value: rule.whereString
                });
            }
            break;
          default:
            return _defineProperty({}, _constants.conditionNames.URL, {
              operator: _constants.defaultOperators.EXACT,
              value: rule.where
            });
        }
      }()]
    }]);
  }

  if (rule.domains && rule.domains !== "") {
    masterClause = [].concat(_toConsumableArray(masterClause), [{
      or: rule.domains.split(",").map(function (value) {
        return _defineProperty({}, _constants.conditionNames.DOMAINS, {
          operator: _constants.defaultOperators.EXACT,
          value: value
        });
      })
    }]);
  }

  var nonExcludedProperties = Object.keys(rule.properties || {}).filter(function (it) {
    return it !== "_ABGroup";
  });

  var hasLanguages = rule.languages && rule.languages !== "";
  var hasProperties = nonExcludedProperties.length > 0;
  var hasContents = rule.contents;
  var hasEvents = rule.events;

  if (hasLanguages || hasProperties || hasContents || hasEvents) {
    var userConditions = [];

    if (hasLanguages) {
      userConditions = [].concat(_toConsumableArray(userConditions), [{
        or: rule.languages.split(",").map(function (value) {
          return _defineProperty({}, _constants.conditionNames.LANGUAGES, {
            operator: _constants.propertyOperators.STARTS_WITH,
            value: value
          });
        })
      }]);
    }

    if (hasContents) {
      var stepId = Object.keys(rule.contents)[0];
      var stepClause = rule.contents[stepId];

      if (stepClause.negative) {
        userConditions = [].concat(_toConsumableArray(userConditions), [{
          not: [_defineProperty({}, _constants.conditionNames.CONTENT, {
            content: stepId,
            times: stepClause.times,
            since: "0"
          })]
        }]);
      } else {
        userConditions = [].concat(_toConsumableArray(userConditions), [_defineProperty({}, _constants.conditionNames.CONTENT, {
          content: stepId,
          times: stepClause.times,
          since: "0"
        })]);
      }
    }

    if (hasEvents) {
      var eventName = Object.keys(rule.events)[0];
      var eventClause = rule.events[eventName];

      if (eventClause.negative) {
        userConditions = [].concat(_toConsumableArray(userConditions), [{
          not: [_defineProperty({}, _constants.conditionNames.EVENT, {
            event: eventName,
            times: eventClause.times,
            since: "0"
          })]
        }]);
      } else {
        userConditions = [].concat(_toConsumableArray(userConditions), [_defineProperty({}, _constants.conditionNames.EVENT, {
          event: eventName,
          times: eventClause.times,
          since: "0"
        })]);
      }
    }

    if (hasProperties) {
      userConditions = [].concat(_toConsumableArray(userConditions), _toConsumableArray(nonExcludedProperties.map(function (property) {
        var recipe = rule.properties[property];

        if ([_constants.propertyOperators.IN, _constants.propertyOperators.NOT_IN].includes(recipe.operator) || !(recipe instanceof Object && "value" in recipe) && recipe.valuesList && recipe.valuesList != "") {
          // these properties work against a list of values
          var valuesList = "valuesList" in recipe ? recipe.valuesList.split(/\n/g) : [];

          if (valuesList.length <= 10) {
            switch (recipe.operator) {
              case _constants.propertyOperators.IN:
                return {
                  or: valuesList.map(function (value) {
                    return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
                      property: property,
                      operator: _constants.propertyOperators.EQUALS,
                      value: value
                    });
                  })
                };
              case _constants.propertyOperators.NOT_IN:
                return {
                  and: valuesList.map(function (value) {
                    return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
                      property: property,
                      operator: _constants.propertyOperators.NOT_EQUALS,
                      value: value
                    });
                  })
                };
            }
          } else {
            return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
              property: property,
              operator: recipe.operator,
              value: valuesList.join("\n")
            });
          }
        } else {
          // this property works against a single value
          var value = recipe.value;

          if (recipe instanceof Object && ("value" in recipe || "valuesList" in recipe)) {
            // handles 'modern' style rules... { properties: { numFlows: { operator: "==", value: 2 } }

            if ([_constants.propertyOperators.EXISTS, _constants.propertyOperators.NOT_EXISTS].includes(recipe.operator)) {
              return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
                property: property,
                operator: recipe.operator
              });
            } else if ([_constants.propertyOperators.LESS_THAN_X_DAYS_AGO, _constants.propertyOperators.GREATER_THAN_X_DAYS_AGO, _constants.propertyOperators.WITHIN_X_DAYS_AGO].includes(recipe.operator)) {
              return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
                property: property,
                operator: recipe.operator,
                value: recipe.value * _constants.millisecondsPerDay
              });
            } else {
              return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
                property: property,
                operator: recipe.operator,
                value: value
              });
            }
          } else {
            // Handles 'original' style rules... { properties: { numFlows: 2 } }

            return _defineProperty({}, _constants.conditionNames.PROPERTIES, {
              property: property,
              operator: _constants.propertyOperators.EQUALS,
              value: recipe
            });
          }
        }
      })));
    }

    masterClause = [].concat(_toConsumableArray(masterClause), [{ and: userConditions }]);
  }

  if (rule.properties && rule.properties["_ABGroup"]) {
    masterClause = [].concat(_toConsumableArray(masterClause), [{
      and: [_defineProperty({}, _constants.conditionNames.PROPERTIES, {
        property: "_ABGroup",
        operator: _constants.defaultOperators.EXACT,
        value: rule.properties["_ABGroup"].value
      })]
    }]);
  }

  return {
    and: masterClause
  };
}